import { gsap, ScrollTrigger } from '../global/gsap';
import vars from '../global/vars';

const initHeaderAnim = (el) => {
    const logo = el.querySelector('.js-header-logo');
    const { body } = vars;
    const isHome = body.classList.contains('page--home');

    if (!logo) return;

    let mm = gsap.matchMedia();

    mm.add('(min-width: 900px)', () => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'top top',
                end: isHome ? `+=${window.innerHeight}` : `+=${logo.offsetHeight}`,
                scrub: 1.05,
                invalidateOnRefresh: true
            }
        });

        tl.to(logo, {
            width: '132px',
        });

        return () => {
            gsap.set(logo, { clearProps: 'all' });
        };
    });
};

export default initHeaderAnim;